export default class MolliePaymentGateway {
    // #region Vars
    _initialized = false;
    _api = {};
    _configuration = {};
    _elements = new Map();
    // #endregion
    // #region Properties
    get isInitialized() {
        return this._initialized;
    }
    get api() {
        return this._api;
    }
    // #endregion
    // #region Boostrap
    async initialize(configuration) {
        // #region Init
        if (!this._initialized) {
            this._configuration = configuration;
            try {
                //Init
                await host.pageMeta.loadScript('https://js.mollie.com/v1/mollie.js');
                //Stripe                
                this._api = Mollie(configuration.profileID, { locale: "de_DE", testmode: true });
            }
            catch (error) {
                utils.logError("Failed to initialize Stripe-Components", error);
            }
            this._initialized = true;
        }
        // #endregion
        return true;
    }
    // #endregion
    // #region Core
    async createElement(name, methodConfiguration) {
        if (this._elements.has(name)) {
            return this._elements.get(name);
        }
        else {
            //Configuration
            let tConfig = methodConfiguration;
            //Merge
            if (this._configuration.elements && this._configuration.elements[name]) {
                tConfig = utils.mergeDeep({}, this._configuration, methodConfiguration);
            }
            //Map
            this._elements.set(name, this.api.createComponent(name, tConfig));
            return this._elements.get(name);
        }
    }
    async handle(command, args) {
        // #region Card
        if (command === 'stripe_handle_card') {
            //Handle
            let tResult1 = await this.api.handleCardAction(args.externalToken);
            //Result
            if (tResult1.error) {
                return {
                    isSucceeded: false,
                    errorCode: tResult1.error.code,
                    errorMessage: tResult1.error.message,
                };
            }
            //Succeeded
            else {
                return {
                    isSucceeded: true,
                    nextAction: 'confirm',
                    data: tResult1.result
                };
            }
        }
        // #endregion
        // #region Url
        else if (command === 'redirect_to_url') {
            //Url
            window.location.href = args.nextActionUrl;
            //Result
            return {
                isSucceeded: true
            };
        }
        // #endregion
        // #region Fallback
        else {
            return {
                isSucceeded: true
            };
        }
        // #endregion
    }
}
